import { WORLD_CUP_WELCOME_STORAGE } from '../worldcup.constants';

export function worldCupWelcomeStorageKey(userId: string | null | undefined): string {
  const trimmed = userId?.trim();
  const suffix = trimmed && trimmed.length > 0 ? trimmed : 'anonymous';
  return `${WORLD_CUP_WELCOME_STORAGE.KEY_PREFIX}.${suffix}`;
}
